import { useQuery } from '@tanstack/react-query';
import { subjectsService, Subject } from 'src/services/subjectsService';

export const SUBJECTS_QUERY_KEY = ['subjects', 'active'] as const;

/**
 * Custom hook to fetch active subjects with react-query caching
 */
export const useActiveSubjects = () => {
  return useQuery({
    queryKey: SUBJECTS_QUERY_KEY,
    queryFn: subjectsService.getActiveSubjects,
    staleTime: 15 * 60 * 1000, // 15 minutes - subjects don't change frequently
    gcTime: 20 * 60 * 1000, // 20 minutes cache time
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};

/**
 * Transform subjects data for the component
 */
export const transformSubjectsForComponent = (subjects: Subject[]) => {
  return subjects.map(subject => ({
    id: subject.id,
    name: subject.name,
    icon: subject.icon || '📚', // Default icon if none provided
    category: subject.category || 'Other', // Default category if none provided
  }));
};